import humps from 'humps'
import Vue from 'vue'
import Vuex from 'vuex'
import {cloneDeep, isEmpty, sortBy} from 'lodash'

import api from '@/lib/api'
import ftoggle from './shared/ftoggle'
import soldto from './shared/soldto'
import register from './register/register'
import toa from './register/toa'
import nda from './nda/nda'
import profile from './profile/profile'
import dashboard from './dashboard/dashboard'
import tester from './tester/tester'
import eventform from './dashboard/events'
import report from './report/reports'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    ftoggle,
    soldto,
    register,
    toa,
    nda,
    profile,
    dashboard,
    tester,
    eventform,
    report
  },

  state: {
    tests: [],
    ndaTemplates: [],
    countries: [],

    saving: false,
    loading: false,
    messages: null,
    webkey: null,
    breadcrumb: [],
    
    webkeyId: null,
    tacId: null,
    admin: false,
    timeStamp: null,
  },
  getters: {
    events: (s) => {
      const a = []
      for (const t of s.tests) {
        a.push(...t.events)
      }
      return sortBy(a, ['id'])
    },
    eventsHidden: (s) => {
      if (!s.tests.length) return []

      const ts = s.tests.filter((x) => ['FTG', 'PRT'].includes(x.mode))
      const a = []

      for (const t of ts) {
        const tmp = t.events.filter((x) => !x.closed)
        a.push(...tmp)
      }
      return sortBy(a, ['name'])
    },
  },
  mutations: {
    tests: (s, a) => (s.tests = isEmpty(a) ? [] : a),
    ndaTemplates: (s, a) => (s.ndaTemplates = isEmpty(a) ? [] : a),
    countries: (s, a) => (s.countries = isEmpty(a) ? [] : a),

    saving: (s, b) => (s.saving = b),
    loading: (s, b) => (s.loading = b),
    breadcrumb: (s, a) => (s.breadcrumb = a),
    webkey: (s, o) => (s.webkey = humps.camelizeKeys(o)),
    clear: (s) => (s.messages = null),
        
    webkeyId: (state, val) => ( state.webkeyId = val ),
    tacId: (state, val) => ( state.tacId = val ),
    admin: (state, val) => ( state.admin = val ),
    timeStamp: (state, val) => ( state.timeStamp = val ),

    messages: (s, v) => {
      const p = cloneDeep(v)
      p.list = p.message.split(';').map((x) => x.trim())

      s.messages = p
    },

    reset: (s) => {
      s.messages = null
      s.breadcrumb = []
    },
  },
  actions: {
    async init({commit}) {
      try {
        const prms0 = api.test.list()
        const prms1 = api.country.list()

        Promise.all([prms0, prms1]).then((resp) => {
          commit('tests', humps.camelizeKeys(resp[0].data))
          commit('countries', humps.camelizeKeys(resp[1].data))
        })
      } catch (e) {
        commit('messages', e.response.data, {root: true})
      }
    },
  },
})
export default store
